import { renouvellementReconduction } from '@/api/commande/index';

export default async function commandeRenouvellementTaciteGetter(id, isRenouvellementOrTacite) {
  if (id === null || id === undefined) {
    return null;
  }
  const devisCommande = (
    await renouvellementReconduction(id, isRenouvellementOrTacite)
  ).data.result;
  return devisCommande;
}
